import { Region } from "../types/region.type";

/**
 * ISO 4217 currency code by region — the single source of truth.
 *
 * Extracted from frontend/lib/ai-search/build-ai-result.ts (which re-imports it)
 * so the budget parser (parse-budget.ts) and the budget enforcement step
 * (budget-enforcement.ts) resolve an ambiguous "$" / compare ceilings against
 * retailer prices with the exact same mapping the public AI-search API uses.
 * Mirrors the maps in product-schema/itemlist-schema.
 */
export function getCurrencyForRegion(region: Region): string {
  const currencyMap: Record<Region, string> = {
    [Region.USA]: "USD",
    [Region.Canada]: "CAD",
    [Region.France]: "EUR",
    [Region.UK]: "GBP",
    [Region.Australia]: "AUD",
    [Region.Brazil]: "BRL",
    [Region.Portugal]: "EUR",
    [Region.Germany]: "EUR",
    [Region.Spain]: "EUR",
    [Region.Italy]: "EUR",
    [Region.Mexico]: "MXN",
    [Region.Switzerland]: "CHF",
    [Region.Austria]: "EUR",
    [Region.Belgium]: "EUR",
    [Region.Netherlands]: "EUR",
    [Region.Poland]: "PLN",
    [Region.Sweden]: "SEK",
    [Region.Ireland]: "EUR",
    [Region.NewZealand]: "NZD",
    [Region.India]: "INR",
    [Region.Argentina]: "ARS",
    [Region.Colombia]: "COP",
    [Region.Chile]: "CLP",
    [Region.Japan]: "JPY",
    [Region.All]: "USD",
  };
  return currencyMap[region] || "USD";
}
